import { useContext } from 'react';
import { ISlideOverModalContext } from '../models/slideOver';
import { SlideOverContext } from '../providers/SlideOverProvider';

// This shouldn't be used around the app
// use *useSlideOverContext* only
// we use this hook internally just to handle modals above slide overs
export const useSlideOverModalContext = (): ISlideOverModalContext => useContext(SlideOverContext);
